export default "__VITE_ASSET__D1q_VHY3__"